import React from 'react';
import PropTypes from 'prop-types';
import {useIntl} from "react-intl";
import Input from '../../Input';
import arrowDown from "../../../assets/arrow-down.svg";
import styles from './styles.module.scss';

const Select = ({
                  onClick,
                  field,
                  form,
                  meta,
                  placeholder,
                  value,
                  ...rest
                }) => {

  const {formatMessage} = useIntl();
  const defaultPlaceholder = formatMessage({
    id: 'common.form.input.select.placeholder',
    defaultMessage: 'Select...'
  });

  const selectValue = () => {
    if (value) return value.label;
    if (field.value) return field.value.label;
    return '';
  };

  return (
    <div className={styles.select}>
      <Input
        onChange={() => {
        }}
        onClick={onClick}
        value={selectValue()}
        readOnly={true}
        error={meta.error && meta.touched}
        placeholder={placeholder || defaultPlaceholder}
        {...rest}
      />
      <img
        src={arrowDown}
        alt="arrow down"
        className={styles.arrowDown}
        onClick={onClick}
      />
    </div>
  )
};

Select.propTypes = {
  onClick: PropTypes.func.isRequired,
  field: PropTypes.object,
  form: PropTypes.object,
  meta: PropTypes.object,
  placeholder: PropTypes.node,
};

export default Select;
